import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { VehicleDto } from 'dtos'

export class ClusterShipperDto {
  clusterShipperGuid?: string = undefined
  clusterShipperNumber?: string = undefined
  numberOfClusters?: number = undefined
  clusterConversionCompany?: CompanyDto = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  dropOffDate?: string = undefined // Format date
  clusterConversionsCompleted?: boolean = false //?
  clusterConversionsCompletedDate?: string = undefined
  vehicles?: VehicleDto[] = undefined
}

export const clusterShipperValidationSchema = yup.object<ClusterShipperDto>({
  clusterConversionCompany: yup.object().required('Cluster Conversion Company is required.'),
  exporterCompany: yup.object().required('Exporter Company is required.')
})
